export var EventName;
(function (EventName) {
    EventName["ExampleEvent"] = "Example Event";
    EventName["ConnectionMethod"] = "Connection Method Selected";
    EventName["PartnerBrokerSearched"] = "Partner Broker Searched";
    EventName["PartnerBrokerSelected"] = "Partner Broker Selected";
    EventName["PartnerEmailSubmitted"] = "Partner Broker Email Submitted";
    EventName["PartnerOTPSubmitted"] = "Partner Broker OTP Submitted";
})(EventName || (EventName = {}));
